module.exports = __webpack_public_path__ + "assets/f05a2ebd1a6132986202d5a8bb624f44.png";